var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"om-hairline-surround",class:_vm.b(( _obj = {
    mark: _vm.mark,
    plain: _vm.plain,
    round: _vm.round
  }, _obj[_vm.type] = _vm.type, _obj[_vm.size] = _vm.size, _obj ))},[_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9e1ac0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/tag/index.vue
// module id = P6mK
// module chunks = 76